import { render, staticRenderFns } from "./TerrasIndigenasEua.vue?vue&type=template&id=b68f99a4&lang=pug"
import script from "./TerrasIndigenasEua.vue?vue&type=script&lang=js"
export * from "./TerrasIndigenasEua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports